<template lang="pug">
    div.image-editor-filters-control
        div.image-editor-control__image-container
            fabric-image-control(:image="image" :filters="applyFilters" :watermark="watermark" @applying="applying = true" @applied="applying = false" ref="editor")
            div.image-editor-control__loader(v-show='applying')
                static-loader-control

        div.image-editor-filters-control__items
            div.image-editor-filters-control__item(v-for='filter in filters'
                    :class='getItemClass(filter.name)' @click='selectFilter(filter.name)')
                div.image-editor-filters-control__item-image(:style="itemImageStyle")
                div {{ filter.label }}
</template>

<script>
import { fabric } from 'fabric'

const Filters = fabric.Image.filters

export default {
    name: 'image-editor-filters-control',

    props: {
        image: {
            type: String,
            required: true,
        },
        watermark: {
            type: Object,
        },
    },

    data() {
        return {
            selectedFilter: null,
            applyFilters: null,
            applying: false,
        }
    },

    computed: {
        filters() {
            return [
                {
                    name: 'none',
                    label: 'None',
                    filters: [],
                },
                {
                    name: 'coffee',
                    label: 'Coffee',
                    filters: [
                        new Filters.BlendColor({ color: 'FF8000', mode: 'tint', alpha: 0.3 }),
                        new Filters.Contrast({ contrast: 0.1 }),
                        new Filters.Brightness({ brightness: -0.06 }),
                    ],
                },
                {
                    name: 'blur',
                    label: 'Blur',
                    filters: [
                        new Filters.Blur({ blur: 0.072 }),
                    ],
                },
                {
                    name: 'classic',
                    label: 'Classic',
                    filters: [
                        new Filters.Brightness({ brightness: 0.15 }),
                        new Filters.BlendColor({ color: 'blue', mode: 'add', alpha: 0.3 }),
                        new Filters.BlendColor({ color: 'FF9000', mode: 'tint', alpha: 0.2 }),
                        new Filters.Saturation({ saturation: 1.2 }),
                        new Filters.Contrast({ contrast: 0.05 }),
                    ],
                },
            ]
        },

        itemImageStyle() {
            return {
                'background-image': `url(${this.image})`,
            }
        },
    },

    watch: {
        image: {
            handler() {
                this.reset()
            },
            immediate: true,
        }
    },

    methods: {
        reset() {
            this.selectedFilter = 'none'
            this.apply()
        },
        apply() {
            this.applyFilters = this.filters.find(f => f.name == this.selectedFilter).filters
        },

        getItemClass(filterName) {
            return {
                'image-editor-filters-control__item--selected': filterName === this.selectedFilter,
            }
        },

        selectFilter(filter) {
            this.selectedFilter = filter
            this.apply()
        },

        getModifiedImage() {
            return this.$refs.editor.getDataURL()
        },
    },
}
</script>
